import { Box, Button, Text, TextInput } from 'grommet';
import { Ascend, Descend, Search, Unsorted } from 'grommet-icons';
import React from 'react'
import sortArray from '../functions/sortArray';
import NumeroListUnit from './NumeroListUnit';

const NumeroList = (props:any) => {
  let Numeros = props.numerolist
  let sOption = props.sortoption
  let cat = props.cat
  const [numeroSorted, setNumeroSorted] = React.useState<any>([])
  const [sortFinished, setSortFinished] = React.useState(false)

  React.useEffect(() => {
    if (sOption !== null) {
      let numeros_sorted = sortArray({
        listx: Numeros,
        soption: sOption,
        dir: 1
      })
      setNumeroSorted(numeros_sorted)
      setSortFinished(true)
    }
  }, [])

  const optColor = "white"
  const optColorNot = "rgb(255,255,255,0.8)"

  return (
    <Box direction="column" align="center" justify="start" width="full">
      {sortFinished && numeroSorted.length > 0 &&<Box
        width="full"
        margin={{ top: "30px" }}
        align="center"
        justify="start"
        overflow={"scroll"}
        direction="column"
      >
        {numeroSorted.map((b: any) => (
          <Box key={b.book_id} width="full" margin="1px"
            alignContent="stretch" fill={true} overflow={"scroll"}
            pad={{ horizontal: "15px" }}
            style={{ minHeight: "50px" }}>
            <NumeroListUnit numeroinfo={b} cat={cat}/>
          </Box>
        ))}
      </Box>}
    </Box>
  )
  

}

export default NumeroList;